import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=6cd4f488"
import script from "./LayoutAuth.vue?vue&type=script&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&lang=js"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=6cd4f488&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd4f488')) {
      api.createRecord('6cd4f488', component.options)
    } else {
      api.reload('6cd4f488', component.options)
    }
    module.hot.accept("./LayoutAuth.vue?vue&type=template&id=6cd4f488", function () {
      api.rerender('6cd4f488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layout/LayoutAuth.vue"
export default component.exports